import React, { FC } from 'react';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface NotificationCenterProps {}

const NotificationCenter: FC<NotificationCenterProps> = () => {
  return (
    <ToastContainer
      position="top-center"
      closeButton={false}
      transition={Slide}
      hideProgressBar={true}
      theme="colored"
      limit={3}
      autoClose={1000}
    />
  );
};

export default NotificationCenter;
